module.exports = __webpack_public_path__ + "img/8dc24a84e5167d83fd393bf66420b532.png";